const lang = {
    'caption': 'One click mobility',
    'subtitle': 'Access an exciting GoShare scooter whenever you need one.',
};

export default lang;
